/**
 * RTL-WALLET-LIFECYCLE (2026-08-24) — Route-scoped suppression list
 * for the global Mission-Control SIWS auto-effect.
 *
 * Any pathname prefix listed here disables the WalletAuthContext
 * auto-SIWS effect on that route. Live evidence proved the effect
 * fired on `/elimination-link` immediately after Phantom's
 * `connect()` resolved, popping an MC-SIWS approval dialog before
 * the user could click the page's own "Sign challenge & finish
 * linking" button. The Discord ownership-link page owns its own
 * dedicated signature flow (`EliminationLink.doSignAndVerify`,
 * nonce-bound Discord-link challenge). MC SIWS on that route is
 * both unwanted and misleading.
 *
 * Extracted to a plain JS module (no JSX / React imports) so it is
 * directly Node-runnable for regression tests. Consumed by
 * `WalletAuthContext.jsx`.
 */
export const AUTO_SIWS_SUPPRESSED_PREFIXES = ['/elimination-link'];

export function isAutoSiwsSuppressedForPath(pathname) {
  if (typeof pathname !== 'string' || !pathname) return false;
  return AUTO_SIWS_SUPPRESSED_PREFIXES.some((p) => pathname.startsWith(p));
}
